import React from "react";
import "./FlipCard.css";

interface FlipCardProps {
  /** Image du recto (visible par défaut) */
  frontSrc: string;
  /** Image du verso (visible au survol / focus) */
  backSrc: string;
  /** Texte alternatif accessible */
  alt: string;
}

/**
 * Carte de visite avec effet de retournement (flip) en 3D.
 * Le retournement se déclenche au survol de la souris ainsi qu'au focus
 * clavier, pour rester accessible. Sur écran tactile, un appui bascule
 * également la carte.
 */
const FlipCard: React.FC<FlipCardProps> = ({ frontSrc, backSrc, alt }) => {
  return (
    <div className="flip-card" tabIndex={0} aria-label={alt}>
      <div className="flip-card-inner">
        <div className="flip-card-face flip-card-front">
          <img src={frontSrc} alt={`${alt} — recto`} loading="lazy" />
        </div>
        <div className="flip-card-face flip-card-back">
          <img src={backSrc} alt={`${alt} — verso`} loading="lazy" />
        </div>
      </div>
    </div>
  );
};

export default FlipCard;
